import { useEffect, useState } from 'react';
import { View } from 'react-native';

import { COLORS, Text } from '../Basics';
import { RING_TONE } from '../../Sound';

/**
 * Alerta de pausa excedida — equivalente a VerificaAlertaPausaProdutiva no PhoenixCliente.
 */
export const PauseExceededAlert = () => {
  const [warning, setWarning] = useState(null);
  const [exceeded, setExceeded] = useState(null);

  useEffect(() => {
    const onWarning = ev => {
      const data = ev.detail || ev.data;
      setWarning(data);
      setExceeded(null);
    };

    const onExceeded = ev => {
      const data = ev.detail || ev.data;
      setExceeded(data);
      setWarning(null);
      try {
        RING_TONE?.play?.();
      } catch {
        /* ignore */
      }
    };

    const onCleared = () => {
      setWarning(null);
      setExceeded(null);
    };

    document.addEventListener('lorentz:pause:warning', onWarning);
    document.addEventListener('lorentz:pause:exceeded', onExceeded);
    document.addEventListener('lorentz:pause:cleared', onCleared);

    return () => {
      document.removeEventListener('lorentz:pause:warning', onWarning);
      document.removeEventListener('lorentz:pause:exceeded', onExceeded);
      document.removeEventListener('lorentz:pause:cleared', onCleared);
    };
  }, []);

  const active = exceeded || warning;
  if (!active) return null;

  const isExceeded = !!exceeded;
  const bg = isExceeded ? COLORS.danger : COLORS.warning;
  const elapsed = active.elapsed ?? 0;
  const limit = active.limit ?? active.alertSec ?? 0;

  return (
    <View
      style={{
        backgroundColor: bg,
        paddingHorizontal: 12,
        paddingVertical: 8,
        borderRadius: 8,
        marginBottom: 6
      }}
    >
      <Text style={{ color: '#fff', fontWeight: 'bold', fontSize: 12 }}>
        {isExceeded ? 'PAUSA EXCEDIDA' : 'Alerta de pausa'}
      </Text>
      <Text style={{ color: '#fff', fontSize: 11, marginTop: 2 }}>
        {active.description ? `${active.description} · ` : ''}
        {Math.floor(elapsed / 60)}:
        {String(elapsed % 60).padStart(2, '0')}
        {limit > 0 ? ` / limite ${Math.floor(limit / 60)}:${String(limit % 60).padStart(2, '0')}` : ''}
      </Text>
    </View>
  );
};

export default PauseExceededAlert;
